import React, {useState} from "react";
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { useFormik } from "formik";
import * as Yup from "yup";
import { login } from "../../services/auth.service";
import {Image} from "react-bootstrap";
import fygLupa from "../../assets/FyG-lupa.png"
import showNotification from "../utils/Notify";
import EventBus from "../utils/EventBus";
import {Box, Card, Input, Button, Stack} from "@mui/joy";
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import KeyIcon from '@mui/icons-material/Key';

type Props = {}

const Login: React.FC<Props> = () => {
  let navigate: NavigateFunction = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);

  const initialValues: {
    username: string;
    password: string;
  } = {
    username: "",
    password: "",
  };

  const validationSchema = Yup.object().shape({
    username: Yup.string().required("This field is required!"),
    password: Yup.string().required("This field is required!"),
  });

  const handleLogin = (formValue: { username: string; password: string }) => {
    const { username, password } = formValue;
    setLoading(true);

    login(username, password)
      .then((response) => {
        EventBus.dispatch("login");
        const roles: string[] = Array.isArray(response.roles) ? response.roles : [];

        const orderedPermissions = [
          "MY_CASH_BOXES",
          "MY_SERVICE_ORDERS",
          "CASH_BOXES",
          "SALES",
          "PURCHASES",
          "SERVICE_ORDERS",
          "PROVIDERS",
          "CLIENTS",
          "USERS_AND_PROFILES",
          "ROLES_AND_PERMISSIONS",
          "PROFILE_VIEW",
        ];

        const firstMatch = orderedPermissions.find((p) => roles.includes(p));

        const routes: Record<string, string> = {
          MY_CASH_BOXES: "/my-cash-boxes",
          MY_SERVICE_ORDERS: "/my-service-orders",
          CASH_BOXES: "/cash-boxes",
          SALES: "/sales",
          PURCHASES: "/purchases",
          SERVICE_ORDERS: "/service-orders",
          PROVIDERS: "/providers",
          CLIENTS: "/clients",
          USERS_AND_PROFILES: "/users",
          ROLES_AND_PERMISSIONS: "/ruta-roles-permisos",
          PROFILE_VIEW: "/roles",
        };

        if (firstMatch && routes[firstMatch]) {
          navigate(routes[firstMatch]);
        }

      }).catch((error) => {
        // const errorMessage = error.response?.data?.message || "An unexpected error occurred.";
        const message = error.response?.status === 401 ? "Usuario y/o Contraseña incorrectos." : "Error al comunicarse con el servidor";
        showNotification({ type: 'error', message: message });
      }).finally( () => setLoading(false));
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    onSubmit: handleLogin,
    validationSchema: validationSchema,
  });

  return (
    <Box
      className="App"
      sx={{
        px: { xs: 2},
        pt: { xs: 'calc(12px + var(--Header-height))' },
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        minWidth: 0,
        height: '100dvh',
        overflow: "auto"
      }}
    >
      <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
        <Card sx={{width:500}}>
          <Stack direction="row" spacing={1} justifyContent="center" p={0} m={0}>
            <Stack direction="column" spacing={0} >
              <span className="Logo-title"><i>F&G TECHNOLOGIES</i></span>
              <span className="Logo-subtitle"><i><u>Gesti&oacute;n Interna</u></i></span>
            </Stack>
            <Image src={fygLupa} alt="FyG Logo" width={100}/>
          </Stack>
          <form className="form" onSubmit={formik.handleSubmit}>
            <Stack spacing={2}>
              <Input
                startDecorator={<AccountBoxIcon/>}
                name="username"
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                placeholder="Usuario"
                error={!!(formik.touched.username && formik.errors.username)}
                sx={{height: 50}}
              />
              <Input
                startDecorator={<KeyIcon/>}
                name="password"
                type="password"
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                placeholder="Contraseña"
                error={!!(formik.touched.password && formik.errors.password)}
                sx={{height: 50}}
              />
              <Button
                type="submit"
                variant="solid"
                className="Button-custom"
                fullWidth
                disabled={loading}
              >
                INGRESAR
              </Button>
            </Stack>
          </form>
          <div className="text-center">
            <a href="forgot-password" className="Forgot-password-link">Forgot password?</a>
          </div>
        </Card>
      </Box>
    </Box>
  );
};

export default Login;
